import React from "react";
import {cn} from "../../utils/cn";

const PALETTE = [
  "bg-brand-700",
  "bg-accent-500",
  "bg-success-600",
  "bg-info-600",
  "bg-warning-600",
  "bg-danger-600",
  "bg-ink-700",
];

function hashIndex(input) {
  const str = String(input || "?");
  let h = 0;
  for (let i = 0; i < str.length; i++) h = str.charCodeAt(i) + ((h << 5) - h);
  return Math.abs(h) % PALETTE.length;
}

function initials(input) {
  return String(input || "?")
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();
}

const sizes = {
  sm: "h-7 w-7 text-2xs rounded-md",
  md: "h-8 w-8 text-xs rounded-md",
  lg: "h-10 w-10 text-sm rounded-lg",
  xl: "h-12 w-12 text-base rounded-lg",
};

/**
 * Avatar with hash-based color. Accepts either `name` (auto-initial), `label` (custom 2-char), or `color` override.
 */
export default function Avatar({name, label, color, size = "md", className, ...props}) {
  const text = label || initials(name);
  const bg = color || PALETTE[hashIndex(name || label)];
  return (
    <span
      className={cn(
        "inline-flex items-center justify-center font-semibold text-white shrink-0",
        bg,
        sizes[size],
        className
      )}
      {...props}
    >
      {text}
    </span>
  );
}
